import React from 'react';
import {
  NepPackageCommunityAddOn,
  NepPackageFloorplanAddOns,
  NepPackageFloorplanInclude,
  NepPackagePhotoAddOns,
  NepPackagePhotoInclude,
} from '~/tenants/nep/package/common';
import { TenantPackageIncludes } from '~/tenants/common/package';
import { TenantPerformableAddOns } from '~/tenants/common/performable';
import { PersonaType } from '~/tenants/common/TenantPersona';

export default function NepPackageBasicForm() {
  return (
    <>
      <TenantPackageIncludes>
        <NepPackagePhotoInclude />
        <NepPackageFloorplanInclude />
      </TenantPackageIncludes>
      <TenantPerformableAddOns persona={PersonaType.CUSTOMER}>
        <NepPackagePhotoAddOns />
        <NepPackageFloorplanAddOns />
        <NepPackageCommunityAddOn />
      </TenantPerformableAddOns>
    </>
  );
}
